(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/fractiongames/assets/react/fractiongames-app.js') >= 0) return;  svs.modules.push('/modules/lotto/components/fractiongames/assets/react/fractiongames-app.js');

'use strict';

const _svs$numbergames = svs.numbergames,
  FractiongamesBanner = _svs$numbergames.FractiongamesBanner,
  productMapping = _svs$numbergames.productMapping;
const FractionGamesProvider = svs.numbergames.fractiongames.redux.FractionGamesProvider;
const Fractiongames = svs.lotto.components.fractiongames.Fractiongames;
const FractiongamesApp = () => React.createElement(React.Fragment, null, React.createElement(FractiongamesBanner, null), React.createElement(FractionGamesProvider, null, React.createElement(Fractiongames, {
  productFilter: productMapping.CONSTANTS.LOTTO
})));
svs.lotto.components.fractiongames.FractiongamesApp = FractiongamesApp;

 })(window);